const STORAGE_KEY = 'productsListSearch';

export const PRODUCTS_LIST_PATH = '/inventory/products';

export type ProductsListLocationState = {
  productsListSearch?: string;
};

export function productsListPath(search?: string): string {
  if (!search?.trim()) {
    return PRODUCTS_LIST_PATH;
  }
  const query = search.startsWith('?') ? search.slice(1) : search;
  return `${PRODUCTS_LIST_PATH}?${query}`;
}

export function persistProductsListSearch(search: string): void {
  try {
    if (search.trim()) {
      sessionStorage.setItem(STORAGE_KEY, search);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // sessionStorage unavailable (private mode, etc.)
  }
}

export function readPersistedProductsListSearch(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}

export function resolveProductsListSearch(location: { state?: unknown }): string {
  const state = location.state as ProductsListLocationState | null | undefined;
  if (state?.productsListSearch) {
    return state.productsListSearch;
  }
  return readPersistedProductsListSearch();
}

export function productsListNavState(search: string): { state: ProductsListLocationState } {
  persistProductsListSearch(search);
  return { state: { productsListSearch: search } };
}

export function carryProductsListNavState(location: {
  state?: unknown;
}): { state: ProductsListLocationState } {
  return productsListNavState(resolveProductsListSearch(location));
}
